 //添加一个的类型
 export default {
	type : {
		STRING: { code: "1", label: 'string'},
		INT: { code: "2", label: 'int' },
		BOOLEAN: { code: "3", label: 'boolean' },
		ARRAY : { code: "4", label: 'array ' },
		OBJECT : { code: "5", label: 'object ' },
	},
	strand:{
		YES: { code: "2", label: '是'},
		NO: { code: "1", label: '不是' },
	},
	options : [
	{
	  value: '1',
	  label: 'string'
	},
	{
	  value: '2',
	  label: 'int '
	},
	{
	  value: '3',
	  label: 'boolean'
	},
	{
	  value: '4',
	  label: 'array '
	},
	{
	  value: '5',
	  label: 'object '
	}
	],


	//
   submenu1 : {
	  PHONE: { code: 1, label: '手机'},
	  PC: { code: 2, label: 'pc' },
	  BOX: { code: 3, label: '盒子' },
	  OTHER: { code: 4, label: '其他' },
	},
	tableData: [
		{
			name: '手机',
			value: '1',
		},
		{
			name: 'pc',
			value: '2',
		},
		{
			name: '盒子',
			value: '3',
		},
		{
			name: '其他',
			value: '4',
		}
	],
   areaData: [
     {
       name: '亚州',
       value: 1,
     },
     {
       name: '欧洲',
       value: 2,
     },
     {
       name: '非洲',
       value: 3,
     },
     {
       name: '北美洲',
       value: 4,
     },
     {
       name: '南美洲',
       value: 5,
     },
     {
       name: '南极洲',
       value: 6,
     },
     {
       name: '大洋洲',
       value: 7,
     }
   ],
   areaType: {
     state:{
       name: '国家',
       value: 1,
     },
     province:{
       name: '省市',
       value: 2,
     },
     county:{
       name: '区县',
       value: 3,
     }
   },
   areaId: {
     AS:{
       name: '亚州',
       value: '0000',
     },
     EU:{
       name: '欧洲',
       value: 2,
     },
     AF:{
       name: '非洲',
       value: 3,
     },
     NA:{
       name: '北美洲',
       value: 4,
     },
     SA:{
       name: '南美洲',
       value: 5,
     },
     AN:{
       name: '南极洲',
       value: 6,
     },
     OA:{
       name: '大洋洲',
       value: 7,
     }
   }

}
